import { render, staticRenderFns } from "./create-game.vue?vue&type=template&id=33c95256&scoped=true&"
import script from "./create-game.vue?vue&type=script&lang=js&"
export * from "./create-game.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33c95256",
  null
  
)

export default component.exports